import { ARBITRUM, BSC } from "config/chains";
import { TOKENS_BY_SYMBOL_MAP } from "./tokens";

const oneInchTokensMap = {
  [ARBITRUM]: {
    BTC: "WBTC",
  },
  [BSC]: {
    BTC: "BTC.b",
    ETH: "WETH.e",
    WBTC: "WBTC.e",
  },
};

export function get1InchSwapUrl(chainId: number, from?: string, to?: string) {
  const rootUrl = `https://app.1inch.io/#/${chainId}/simple/swap`;
  const chainTokensMap = TOKENS_BY_SYMBOL_MAP[chainId];
  const isInvalidInput = !from || !to || !chainTokensMap[from] || !chainTokensMap[to];
  if (isInvalidInput) {
    return rootUrl;
  }
  const fromToken = oneInchTokensMap[chainId]?.[from] || from;
  const toToken = oneInchTokensMap[chainId]?.[to] || to;
  return `${rootUrl}/${fromToken}/${toToken}`;
}

export function get1InchSwapUrlFromAddresses(chainId: number, fromAddress?: string, toAddress?: string) {
  const addressesStr = [fromAddress, toAddress].filter(Boolean).join("/");
  return `https://app.1inch.io/#/${chainId}/simple/swap/${addressesStr}`;
}

export function getLeaderboardLink(chainId) {
  if (chainId === ARBITRUM) {
    return "https://www.money.house/arbitrum/leaderboard";
  }
  if (chainId === BSC) {
    return "https://www.money.house/bsc/leaderboard";
  }
  return "https://www.money.house";
}

// On-platform docs (hash router → /#/docs/<section>)
export const DOCS_LINKS = {
  multiplierPoints: "https://moneyxpro.com/#/docs/staking",
  fundingFees: "https://moneyxpro.com/#/docs/fees",
  adaptiveFunding: "https://moneyxpro.com/#/docs/liquidity",
  borrowingFees: "https://moneyxpro.com/#/docs/fees",
};

export const ARBITRUM_INCENTIVES_V2_URL =
  "https://moneyio.notion.site/MONEY-STIP-Bridge-Incentives-6967a56615b644eabc10f9a1a81b83ab";
export const AVALANCHE_INCENTIVES_V2_URL =
  "https://moneyio.notion.site/MONEY-Summer-Boost-provide-liquidity-and-trade-perpetuals-to-grab-your-share-of-RON-rewards-13638f2e28934460a242f72def4f7d36";

export function getIncentivesV2Url(chainId: number): string {
  if (chainId === ARBITRUM) {
    return ARBITRUM_INCENTIVES_V2_URL;
  }

  if (chainId === BSC) {
    return AVALANCHE_INCENTIVES_V2_URL;
  }

  return ARBITRUM_INCENTIVES_V2_URL;
}
